import { LONG_DASH } from '@dealstack/frontend/shared/other/react/specialSigns';

export const joinPartyNames = (people: Array<{ name?: string | null }>): string => {
	const names = people.map((p) => p.name?.trim()).filter((n): n is string => !!n);
	return Array.from(new Set(names)).join(', ') || LONG_DASH;
};
